<template>
  <div class="entertipPage">
    <div class="basic">
      <div class="textTitle">公告内容</div>
      <div class="text">{{ listData.notice }}</div>
    </div>
    <div class="basic" v-if="listData.attachments !== undefined && listData.attachments.length > 0">
      <div class="textTitle">附件</div>
      <div class="text reminder" v-if="listData.attachments !== undefined && listData.attachments.length > 0">
        提示：点击预览或下载附件
      </div>
      <div v-for="(item, index) in listData.attachments" :key="index" @click="attachsDetail(item.attachUrl)"
           class="attachs">
        <div v-if="item.fileType ==='pdf'" class="icon_pdf"></div>
        <div v-else-if="item.fileType ==='xls' || item.fileType ==='xlsx'" class="icon_excel"></div>
        <div v-else-if="item.fileType ==='doc' || item.fileType ==='docx'" class="icon_word"></div>
        <div v-else-if="item.fileType ==='ppt' || item.fileType ==='pptx'" class="icon_ppt"></div>
        <div v-else class="icon_file_default">
          <div class="other-file-type">{{ item.fileType }}</div>
        </div>
        <div class="attachName">{{ item.attachName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getNotice} from '@api/invitationBids'

export default {
  name: 'entertipPage',
  data() {
    return {
      projectId: '',
      listData: {}
    }
  },
  mounted() {
    this.projectId = this.$route.query.projectId
    this.getNotice()
  },
  methods: {
    getNotice() {
      getNotice({
        projectId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.listData = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    attachsDetail(url) {
      this.$bridge.callHandler('newPage', {url: url}, response => {
        console.log('response:', response)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.entertipPage {
  padding-top: 15px;

  .basic {
    .title {
      @include add_size($font_size_17);
      font-weight: 600;
    }

    .addressBox {
      margin-top: 15px;
    }

    .textTitle {
      @include add_size($font_size_16);
      line-height: 22px;
      font-weight: 600;
    }

    .text {
      @include add_size($font_size_17);
      margin-bottom: 15px;
    }

    .text:last-child {
      margin-bottom: 0;
    }

    .other-file-type {
      text-align: center;
      line-height: 84px;
      color: white;
      font-size: 14px;
    }

    .attachName {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
